import React from 'react';
import { MatchdayCard } from 'app/components/matchCalendar/matchdayCard';
import { MatchRow } from 'app/components/match/matchRow/MatchRow';
import { MatchRowsCardWrapper } from 'app/components/match/matchRow/MatchRowStyles';
export default function CompetitionMatchday(_ref) {
  let {
    data
  } = _ref;
  return /*#__PURE__*/React.createElement(MatchdayCard, {
    key: data.round.id,
    competitionGroup: data,
    extendWithAgeGroup: '',
    className: "",
    "data-sentry-element": "MatchdayCard",
    "data-sentry-component": "CompetitionMatchday",
    "data-sentry-source-file": "CompetitionMatchday.tsx"
  }, /*#__PURE__*/React.createElement(MatchRowsCardWrapper, {
    "data-sentry-element": "MatchRowsCardWrapper",
    "data-sentry-source-file": "CompetitionMatchday.tsx"
  }, data.matches.map(match => /*#__PURE__*/React.createElement(MatchRow, {
    key: match.id,
    match: match,
    colored: false
  }))));
}